import { RxJsonSchema, RxDocument } from 'rxdb';
import { User } from '../models/user'

export const userMethods = {
    getFullName() {
        return User.getUserFullName(this)
    }
}

export type UserDoc = RxDocument<User,typeof userMethods>

export const userSchema: RxJsonSchema<User> = {
    title: 'user schema',
    version: 1,
    keyCompression: false,
    type: 'object',
    properties: {
        _id: {
            type: 'string',
            primary: true
        },
        firstName: { type: 'string' },
        lastName: { type: 'string' },
        email: { type: 'string' },
        phone: { type: ['string','null'] },
        role: { type: 'string' },
        loginFailCnt: { type: 'number' },
        updatedAt: { type: 'number' }
    },
    indexes: [ 'email', ['firstName','lastName'], 'updatedAt']
};

export const userPullQueryBuilder = () => {
    return (doc) => {
        if (!doc) {
            doc = { 
                _id: '',
                role: '',
                firstName: '',
                lastName: '',
                email: '',
                phone: '',
                loginFailCnt: 0,
                updatedAt: 0, 
                deleted: false,
                _rev: ''
            }
        }

        const query = `{ feedForRxdbUsers(lastId: "${doc._id}", minUpdatedAt: ${doc.updatedAt}){
            _id role firstName lastName email phone updatedAt loginFailCnt deleted _rev } }`;
        return {
            query,
            variables: {}
        };
    };
};

